import { ok as assert } from "devlop";
import { is } from "unist-util-is";
function createState(nodeHandlers, markHandlers) {
    const state = {
        one,
        all,
        nodeHandlers,
        markHandlers
    };
    function one(pmNode, parent) {
        const schema = pmNode.type.schema;
        const nodeName = pmNode.type.name;
        const handler = state.nodeHandlers[nodeName];
        if (handler) {
            return handler(pmNode, parent, state);
        }
        if (pmNode.type === schema.topNodeType) {
            const children = state.all(pmNode);
            assert(!children.some((child)=>is(child, "root")), "Expected non-root nodes");
            return {
                type: "root",
                children: children
            };
        }
        if (pmNode.type === schema.nodes["text"]) {
            // Text nodes always have a text property
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return {
                type: "text",
                value: pmNode.text
            };
        }
        return null;
    }
    function processChildPartition(nodes, parent) {
        const firstChild = nodes[0];
        const firstMark = firstChild?.marks[0];
        if (!firstMark) return nodes.map((node)=>state.one(node.node, parent));
        const children = hydrateMarks(nodes.map(({ node, marks })=>({
                node,
                marks: marks.slice(1)
            })), parent);
        const handler = state.markHandlers[firstMark.type.name];
        if (!handler) return children;
        return handler(firstMark, parent, children, state);
    }
    function hydrateMarks(children, parent) {
        const partitioned = children.reduce((acc, child)=>{
            const lastPartition = acc[acc.length - 1];
            if (!lastPartition) {
                return [
                    [
                        child
                    ]
                ];
            }
            const lastChild = lastPartition[lastPartition.length - 1];
            if (!lastChild) {
                return [
                    ...acc.slice(0, acc.length),
                    [
                        child
                    ]
                ];
            }
            if (!child.marks.length && !lastChild.marks.length || child.marks.length && lastChild.marks.length && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            child.marks[0]?.eq(lastChild.marks[0])) {
                return [
                    ...acc.slice(0, acc.length - 1),
                    [
                        ...lastPartition.slice(0, lastPartition.length),
                        child
                    ]
                ];
            }
            return [
                ...acc,
                [
                    child
                ]
            ];
        }, []);
        return partitioned.flatMap((nodes)=>processChildPartition(nodes, parent)).filter((node)=>!!node).flat();
    }
    function all(pmNode) {
        return hydrateMarks(pmNode.children.map((child)=>({
                node: child,
                marks: child.marks
            })), pmNode);
    }
    return state;
}
export function fromProseMirror(pmNode, options) {
    const state = createState(options.nodeHandlers, options.markHandlers);
    return state.one(pmNode);
}
export function fromPmNode(type, getAttrs) {
    return (node, _, state)=>{
        const children = state.all(node);
        const result = {
            type,
            ...getAttrs?.(node),
            children
        };
        return result;
    };
}
export function fromPmMark(type, getAttrs) {
    return (mark, _, mdastChildren)=>{
        const result = {
            type,
            ...getAttrs?.(mark),
            children: mdastChildren
        };
        return result;
    };
}
